let nav = {
  init: function() {
    this.cacheDOM();
    this.insertChapterBackgroundPreloadHints();
    this.bindEvents();
  },
  cacheDOM: function() {
    this.$nav = document.querySelector('nav');
  this.$scoreWrapper = this.$nav.querySelector('.nav-score-wrapper');
  this.$scoreToggle = this.$nav.querySelector('.score-toggle');
    this.$chaptersWrapper = this.$nav.querySelector('.nav-chapters-wrapper');
    this.$logo = this.$nav.querySelector('.tt');
    this.$startOver = document.querySelector('.start-over-wrapper');
    this.$chaptersDropdown = document.getElementById('chapters-dropdown');
    this.$scoreDropdown = document.getElementById('score-dropdown');
    this.$chapterItems = this.$chaptersDropdown ? this.$chaptersDropdown.querySelectorAll('.chapter') : [];
      this._chapterBgUseB = false;
      this.$progressBar = this.$nav.querySelector('.nav-progress-bar');
      this.$progressInner = this.$nav.querySelector('.nav-progress-inner');
      this.$progressLabel = this.$nav.querySelector('.nav-progress-label');
      this.$pagesContainer = document.querySelector('.pages-container');
      this.$pages = this.$pagesContainer ? this.$pagesContainer.querySelectorAll('.page') : [];
      this._chapterBgImageUrls = [
        this.resolveAssetUrl('img/ch1-bg.jpg'),
        this.resolveAssetUrl('img/ch2-bg.jpg'),
        this.resolveAssetUrl('img/ch3-bg.jpg'),
        this.resolveAssetUrl('img/ch4-bg.jpg'),
        this.resolveAssetUrl('img/ch5-bg.jpg')
      ];
    this._desktopMQ = window.matchMedia('(min-width: 768px)');
  },
  refreshPages: function() {
    // Re-cache pages & container dimensions after a layout mode switch (desktop <-> mobile) or major resize
    this.$pagesContainer = document.querySelector('.pages-container');
    this.$pages = this.$pagesContainer ? this.$pagesContainer.querySelectorAll('.page') : [];
    // Force a progress recalculation immediately
    this.setProgressBar(this.getScrollPercent());
  },
  bindEvents: function() {
    // Score toggle
    if (this.$scoreToggle) {
      this.$scoreToggle.addEventListener('click', () => this.toggleDropdown(this.$scoreDropdown));
      this.$scoreToggle.addEventListener('keydown', (e) => { if (['Enter',' '].includes(e.key)) { e.preventDefault(); this.toggleDropdown(this.$scoreDropdown); }});
    }
    // Scroll progress bar: sync with momentum if available; otherwise fallback to native scroll listener + RAF.
    if (this.$pagesContainer && this.$progressBar) {
      // Always keep progress bar in sync with modal or scroll; resilient to exceptions
      const updateProgress = () => {
        try {
          const percent = this.getScrollPercent();
          this.setProgressBar(percent);
        } catch (err) {
          // Attempt recovery by refreshing pages then retry soon
          this.refreshPages();
        }
        requestAnimationFrame(updateProgress);
      };
      requestAnimationFrame(updateProgress);
      // On resize, refresh page references then recalc (some browsers fire many; debounce with requestAnimationFrame)
      let resizeScheduled = false;
      window.addEventListener('resize', () => {
        if (resizeScheduled) return;
        resizeScheduled = true;
        requestAnimationFrame(() => {
          this.refreshPages();
          resizeScheduled = false;
        });
      });
      // Listen for breakpoint mode switches (desktop <-> mobile) and refresh pages/percent
      if (this._desktopMQ) {
        this._desktopMQ.addEventListener('change', () => {
          this.refreshPages();
        });
      }
    }
    // Score close icon inside wrapper (if present)
    if (this.$scoreWrapper) {
      const scoreClose = this.$scoreWrapper.querySelector('.close');
      if (scoreClose) {
        const activate = (e) => {
          if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
          if (e.type === 'keydown') e.preventDefault();
          this.toggleDropdown(this.$scoreDropdown);
        };
        scoreClose.setAttribute('tabindex','0');
        scoreClose.addEventListener('click', activate);
        scoreClose.addEventListener('keydown', activate);
      }
    }
    // Chapters wrapper
    if (this.$chaptersWrapper) {
      this.$chaptersWrapper.addEventListener('click', () => { this.toggleDropdown(this.$chaptersDropdown); this.updateChaptersIcon(); });
      this.$chaptersWrapper.addEventListener('keydown', (e) => { if (['Enter',' '].includes(e.key)) { e.preventDefault(); this.toggleDropdown(this.$chaptersDropdown); this.updateChaptersIcon(); }});
    }
    // Logo scroll
    if (this.$logo) {
      this.$logo.addEventListener('click', () => this.scrollToStart());
      this.$logo.addEventListener('keydown', (e) => { if (['Enter',' '].includes(e.key)) { e.preventDefault(); this.scrollToStart(); }});
    }
    // Start over button scroll
    if (this.$startOver) {
      const activate = (e) => {
        if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
        if (e.type === 'keydown') e.preventDefault();
        this.scrollToStart();
      };
      this.$startOver.addEventListener('click', activate);
      this.$startOver.addEventListener('keydown', activate);
    }
    // Chapter items
    if (this.$chapterItems && this.$chapterItems.length) {
      this.$chapterItems.forEach(item => {
        const handler = (e) => {
          if (e.type === 'keydown' && !['Enter',' '].includes(e.key)) return;
          if (e.type === 'keydown') e.preventDefault();
          // Use instant behavior to avoid end-of-scroll bounce/twitch
          this.scrollToPage(item.dataset.pageLink, { behavior: 'instant' });
        };
        item.setAttribute('tabindex','0');
        item.addEventListener('click', handler);
        item.addEventListener('keydown', handler);
      });

      this.preloadChapterDropdownBackgrounds();
      this.setupChapterBackgroundCrossfade();
    }
    // Outside click & escape
    document.addEventListener('click', (e) => {
      const open = document.querySelectorAll('.nav-dropdown.open');
      if (!open.length) return;
      const triggers = [this.$scoreWrapper, this.$chaptersWrapper];
      const clickedTrigger = triggers.some(t => t && t.contains(e.target));
      const clickedDropdown = Array.from(open).some(d => d.contains(e.target));
      if (!clickedTrigger && !clickedDropdown) this.closeAllDropdowns();
    });
    document.addEventListener('keydown', (e) => {
      if (this.handleArrowKeyNavigation(e)) return;
      if (e.key === 'Escape') this.closeAllDropdowns();
    });
    // Initial icon state
    this.updateChaptersIcon();
  },
  handleArrowKeyNavigation: function(e) {
    if (!['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) return false;
    if (e.altKey || e.ctrlKey || e.metaKey) return false;

    const target = e.target;
    if (target) {
      const tag = target.tagName;
      if (target.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)) {
        return false;
      }
    }

    let delta = 0;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') delta = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') delta = 1;
    if (delta === 0) return false;

    e.preventDefault();
    this.stepPagesByKeyboard(delta);
    return true;
  },
  stepPagesByKeyboard: function(delta) {
    if (!this.$pagesContainer || !this.$pages || !this.$pages.length) {
      this.refreshPages();
    }
    if (!this.$pages || !this.$pages.length) return;

    const pagesArr = Array.from(this.$pages);
    const currentIndex = this.getCurrentPageIndex();
    const nextIndex = Math.min(Math.max(currentIndex + delta, 0), pagesArr.length - 1);
    if (nextIndex === currentIndex) return;

    const pageEl = pagesArr[nextIndex];
    const pageId = pageEl && (pageEl.getAttribute('data-id') || pageEl.id);
    if (!pageId) return;

    // Instant page snap makes held key repeats advance rapidly without smooth-scroll lag.
    this.scrollToPage(pageId, { behavior: 'instant' });
  },
  getCurrentPageIndex: function() {
    if (window.scroll && typeof window.scroll.getCurrentPageIndex === 'function') {
      return window.scroll.getCurrentPageIndex();
    }
    if (!this.$pagesContainer || !this.$pages || !this.$pages.length) return 0;

    const pagesArr = Array.from(this.$pages);
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const scrollPos = isDesktop ? this.$pagesContainer.scrollLeft : this.$pagesContainer.scrollTop;

    let bestIndex = 0;
    let bestDist = Infinity;
    pagesArr.forEach((page, index) => {
      const pos = isDesktop ? page.offsetLeft : page.offsetTop;
      const dist = Math.abs(pos - scrollPos);
      if (dist < bestDist) {
        bestDist = dist;
        bestIndex = index;
      }
    });

    return bestIndex;
  },
  toggleDropdown: function(target) {
    if (!target) return;
    const isOpen = target.classList.contains('open');
    const others = Array.from(document.querySelectorAll('.nav-dropdown.open')).filter(d => d !== target);
    if (isOpen) {
      this.closeDropdown(target);
      return;
    }
    // Prepare new target on top
    target.classList.add('above');
    requestAnimationFrame(() => {
      target.classList.add('open');
      this.updateAriaState(target, true);
      if (target.id === 'chapters-dropdown' && this.$chaptersWrapper) {
        this.$chaptersWrapper.classList.add('open');
      }
      if (target.id === 'score-dropdown' && this.$scoreWrapper) {
        this.$scoreWrapper.classList.add('open');
      }
      // Close others after new is fully visible
      const handle = (e) => {
        if (e.target !== target) return;
        target.classList.remove('above');
        others.forEach(o => this.closeDropdown(o));
        target.removeEventListener('transitionend', handle);
      };
      target.addEventListener('transitionend', handle);
    });
    if (target.id === 'chapters-dropdown') this.updateChaptersIcon();
    if (target.id === 'score-dropdown') this.updateChaptersIcon(); // keep icon in sync when switching
  },
  closeDropdown: function(drop) {
    if (!drop) return;
    drop.classList.remove('open','above');
    this.updateAriaState(drop, false);
    if (drop.id === 'chapters-dropdown') this.updateChaptersIcon();
    if (drop.id === 'chapters-dropdown') this.clearChapterBackgroundCrossfade();
    if (drop.id === 'chapters-dropdown' && this.$chaptersWrapper) {
      this.$chaptersWrapper.classList.remove('open');
    }
    if (drop.id === 'score-dropdown' && this.$scoreWrapper) {
      this.$scoreWrapper.classList.remove('open');
    }
  },
  closeAllDropdowns: function() {
    document.querySelectorAll('.nav-dropdown.open').forEach(d => this.closeDropdown(d));
  },
  updateAriaState: function(el, isOpen) {
    if (!el) return;
    el.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    el.setAttribute('aria-modal', isOpen ? 'true' : 'false');
  },
  updateChaptersIcon: function() {
    const chaptersDropdown = this.$chaptersDropdown;
    const hamburger = this.$chaptersWrapper && this.$chaptersWrapper.querySelector('.hamburger');
    if (!hamburger) return;
    if (chaptersDropdown && chaptersDropdown.classList.contains('open')) {
  hamburger.innerHTML = '<img src="./img/text-modal-close.svg" alt="Close" />';
    } else {
      hamburger.innerHTML = '<div class="line"></div><div class="line"></div><div class="line"></div>';
    }
  },
  setupChapterBackgroundCrossfade: function() {
    if (!this.$chaptersDropdown || !this.$chapterItems || !this.$chapterItems.length) return;

    const chapterBgByIndex = {
      2: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${this._chapterBgImageUrls[0]}')`,
      3: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${this._chapterBgImageUrls[1]}')`,
      4: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${this._chapterBgImageUrls[2]}')`,
      5: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${this._chapterBgImageUrls[3]}')`,
      6: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url('${this._chapterBgImageUrls[4]}')`
    };

    const canCrossfade = () => this._desktopMQ && this._desktopMQ.matches;

    const applyBackground = (chapterEl) => {
      if (!canCrossfade() || !chapterEl) return;
      if (chapterEl.classList.contains('wide-chapter')) {
        this.clearChapterBackgroundCrossfade();
        return;
      }

      const idx = Array.from(this.$chapterItems).indexOf(chapterEl) + 1;
      const bg = chapterBgByIndex[idx];
      if (!bg) return;

      this._chapterBgUseB = !this._chapterBgUseB;
      if (this._chapterBgUseB) {
        this.$chaptersDropdown.style.setProperty('--chapters-bg-b', bg);
        this.$chaptersDropdown.classList.add('bg-b-active');
      } else {
        this.$chaptersDropdown.style.setProperty('--chapters-bg-a', bg);
        this.$chaptersDropdown.classList.remove('bg-b-active');
      }
    };

    this.$chapterItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        applyBackground(item);
      });
      item.addEventListener('mouseleave', () => {
        this.clearChapterBackgroundCrossfade();
      });
      item.addEventListener('focus', () => {
        applyBackground(item);
      });
      item.addEventListener('blur', () => {
        this.clearChapterBackgroundCrossfade();
      });
    });

    this.$chaptersDropdown.addEventListener('mouseleave', () => this.clearChapterBackgroundCrossfade());
    this.$chaptersDropdown.addEventListener('focusout', (e) => {
      if (!this.$chaptersDropdown.contains(e.relatedTarget)) {
        this.clearChapterBackgroundCrossfade();
      }
    });

    if (this._desktopMQ) {
      this._desktopMQ.addEventListener('change', () => {
        if (!this._desktopMQ.matches) this.clearChapterBackgroundCrossfade();
      });
    }
  },
  clearChapterBackgroundCrossfade: function() {
    if (!this.$chaptersDropdown) return;
    this.$chaptersDropdown.style.removeProperty('--chapters-bg-a');
    this.$chaptersDropdown.style.removeProperty('--chapters-bg-b');
    this.$chaptersDropdown.classList.remove('bg-b-active');
    this._chapterBgUseB = false;
  },
  insertChapterBackgroundPreloadHints: function() {
    if (!this._chapterBgImageUrls || !this._chapterBgImageUrls.length) return;
    if (!document.head) return;
    this._chapterBgImageUrls.forEach((href) => {
      const existing = document.head.querySelector(`link[rel="preload"][as="image"][href="${href}"]`);
      if (existing) return;
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = href;
      link.setAttribute('fetchpriority', 'high');
      document.head.appendChild(link);
    });
  },
  preloadChapterDropdownBackgrounds: function() {
    if (!this._chapterBgImageUrls || !this._chapterBgImageUrls.length) return;
    this._chapterBgImageUrls.forEach((src) => {
      const img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'high';
      img.loading = 'eager';
      img.src = src;
    });
  },
  resolveAssetUrl: function(assetPath) {
    const base = (import.meta && import.meta.env && import.meta.env.BASE_URL) || '/';
    const baseUrl = new URL(base, window.location.href);
    return new URL(assetPath.replace(/^\//, ''), baseUrl).toString();
  },
  scrollToStart: function() {
    const container = document.querySelector('.pages-container');
    if (!container) return;
    // If zoom modal is open, close it before scrolling to start
    if (window.pageZoom && window.pageZoom.active && typeof window.pageZoom.close === 'function') {
      window.pageZoom.close();
    }
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const startTime = performance.now();
    const duration = 1500;
    const initialX = container.scrollLeft;
    const initialY = container.scrollTop;
    const inOutCubic = (t) => t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
    function step(now) {
      const t = Math.min(1, (now - startTime) / duration);
      const eased = inOutCubic(t);
      if (isDesktop) container.scrollLeft = initialX * (1 - eased); else container.scrollTop = initialY * (1 - eased);
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  },
  scrollToPage: function(pageId, opts = {}) {
      const container = document.querySelector('.pages-container');
      if (!container) return;
      // Accept optional options object as second arg
      let skipZoomClose = false;
      if (typeof pageId === 'object' && pageId !== null) {
        // Called as scrollToPage(pageId, { skipZoomClose: true })
        skipZoomClose = !!pageId.skipZoomClose;
        pageId = pageId.pageId;
      }
      const behavior = opts.behavior || 'animated'; // 'animated' | 'instant'
      // If zoom modal is open, close it before scrolling to target page (unless skipZoomClose)
      if (!skipZoomClose && window.pageZoom && window.pageZoom.active && typeof window.pageZoom.close === 'function') {
        window.pageZoom.close();
      }
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const targetPage = container.querySelector(`.page[data-id="${pageId}"]`);
    if (!targetPage) return;
    // Close chapters if open
    if (this.$chaptersDropdown && this.$chaptersDropdown.classList.contains('open')) {
      this.closeDropdown(this.$chaptersDropdown);
    }

    // Smooth scroll animation
    function inOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
    }
    function animateTo(finalX, finalY, duration) {
      if (typeof duration === 'undefined') duration = 650;
      var startTime = performance.now();
      var initialX = container.scrollLeft;
      var initialY = container.scrollTop;
      function step(now) {
        var t = Math.min(1, (now - startTime) / duration);
        var eased = inOutCubic(t);
        if (isDesktop) {
          container.scrollLeft = initialX + (finalX - initialX) * eased;
        } else {
          container.scrollTop = initialY + (finalY - initialY) * eased;
        }
        if (t < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    const computeFinalOffsets = () => {
      let finalX = targetPage.offsetLeft;
      let finalY = targetPage.offsetTop;
      if (isDesktop) {
        // Desktop: align the target page's left edge with the container's left edge (no centering)
        finalX = targetPage.offsetLeft; // left-align
      } else {
        const navHeight = parseInt(getComputedStyle(document.querySelector('nav')).height, 10) || 0;
        finalY = targetPage.offsetTop - navHeight - 18; // offset past nav
      }
      return { finalX, finalY };
    };

    // Preload surrounding pages to reduce later layout shifts
    this.preloadSurroundingPages(targetPage);

    // Initial scroll
    const first = computeFinalOffsets();
    if (behavior === 'instant') {
      if (isDesktop) {
        container.scrollLeft = first.finalX;
      } else {
        container.scrollTop = first.finalY;
      }
    } else {
      animateTo(first.finalX, first.finalY);
    }

    // Re-align after image decode or load (target only)
    const img = targetPage.querySelector('img');
  if (behavior !== 'instant' && img && !img.complete) {
      // Attempt to raise priority
      try { img.fetchPriority = 'high'; } catch(_){}
      if (img.decode) {
        img.decode().then(() => {
          const { finalX, finalY } = computeFinalOffsets();
          animateTo(finalX, finalY, 300);
        }).catch(() => {/* ignore */});
      } else {
        const handleLoad = () => {
          const { finalX, finalY } = computeFinalOffsets();
          animateTo(finalX, finalY, 300);
        };
        img.addEventListener('load', handleLoad, { once: true });
      }
    }

    // Stability sampling: adjust once layout stops shifting or timeout
    if (behavior !== 'instant') {
      this._stabilizeScroll(targetPage, isDesktop, () => {
        const { finalX, finalY } = computeFinalOffsets();
        // Only animate correction if meaningful delta to reduce perceptible twitch
        const delta = isDesktop ? Math.abs(container.scrollLeft - finalX) : Math.abs(container.scrollTop - finalY);
        if (delta > 6) {
          animateTo(finalX, finalY, 220);
        } else {
          if (isDesktop) container.scrollLeft = finalX; else container.scrollTop = finalY;
        }
      });
    }
  },
  /**
   * Sample target position until it stops shifting (due to late image loads) then invoke cb.
   */
  _stabilizeScroll: function(targetPage, isDesktop, cb) {
    const MAX_TIME = 1800; // ms
    const INTERVAL = 90; // ms
    const STABLE_SAMPLES = 3; // consecutive stable readings
    let stableCount = 0;
    let lastPos = null;
    const start = performance.now();
    const sample = () => {
      const pos = isDesktop ? targetPage.offsetLeft : targetPage.offsetTop;
      if (lastPos !== null && Math.abs(pos - lastPos) < 2) {
        stableCount++;
      } else {
        stableCount = 0;
      }
      lastPos = pos;
      const elapsed = performance.now() - start;
      if (stableCount >= STABLE_SAMPLES || elapsed > MAX_TIME) {
        cb && cb();
        return;
      }
      setTimeout(sample, INTERVAL);
    };
    sample();
  },
  /**
   * Preload target page image and a few neighbors to reduce layout shift before/after navigation.
   */
  preloadSurroundingPages: function(targetPage) {
    if (!this.$pages || !this.$pages.length) return;
    const pagesArr = Array.from(this.$pages);
    const idx = pagesArr.indexOf(targetPage);
    if (idx === -1) return;
    const toPreload = [];
    for (let i = idx - 2; i <= idx + 2; i++) {
      if (i < 0 || i >= pagesArr.length) continue;
      toPreload.push(pagesArr[i]);
    }
    toPreload.forEach(p => {
      const img = p.querySelector('img');
      if (!img) return;
      if (img.complete) return; // already loaded
      try { img.fetchPriority = 'high'; } catch(_){}
      const src = img.getAttribute('src');
      if (!src) return;
      const pre = new Image();
      pre.src = src;
    });
  },
  getScrollPercent: function() {
    if (!this.$pagesContainer || !this.$pages.length) return 0;
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;
    const max = isDesktop
      ? (this.$pagesContainer.scrollWidth - this.$pagesContainer.clientWidth)
      : (this.$pagesContainer.scrollHeight - this.$pagesContainer.clientHeight);
    if (max <= 0) return 0; // no scrollable distance -> start at 0%
    const current = isDesktop ? this.$pagesContainer.scrollLeft : this.$pagesContainer.scrollTop;
    const percent = Math.round((current / max) * 100);
    return Math.min(100, Math.max(0, percent));
  },
  setProgressBar: function(percent) {
    if (!this.$progressInner) return;
    this.$progressInner.style.width = percent + '%';
    if (this.$progressLabel) {
      if (this.$pages && this.$pages.length) {
        const total = this.$pages.length;
        let currentDisplay;
        if (window.pageZoom && window.pageZoom.active && typeof window.pageZoom._currentIndex === 'number') {
          currentDisplay = window.pageZoom._currentIndex + 1;
        } else {
          const pageApprox = Math.round(percent / 100 * total);
          currentDisplay = Math.min(Math.max(pageApprox, 1), total);
        }
        this.$progressLabel.textContent = `${currentDisplay} / ${total}`;
      } else {
        this.$progressLabel.textContent = `${percent}%`;
      }
      this.$progressBar.setAttribute('aria-valuenow', percent);
      this.$progressBar.setAttribute('aria-valuemax', '100');
      this.$progressBar.setAttribute('aria-valuemin', '0');
    }
  },
}
export default nav;